const defaultState = () => ({
  urlParams: {
    id: null,
    parent_id: null,
    channel_selection: null
  },
  uploadProgress: {},

  onPage: null,

  upload: {
    files: null,
    folder_name: null,
    path: null
  }
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_UPLOAD (state, upload) {
    state.upload = upload
  },

  SET_URL_PARAMS (state, urlParams) {
    state.urlParams = urlParams
  },

  SET_PAGE (state, page) {
    state.onPage = page
  },

  SET_STORE_NULL (state) {
    state.upload = {}
  },

  SET_FILE_UPLOAD_PROGRESS (state, { progress, id }) {
    state.uploadProgress = { ...state.uploadProgress, [id]: progress }
  }
}
export const actions = {
  // Fetch steps from api:
  checkActivationKey () {

  }
}
